module.exports = __webpack_public_path__ + "img/background-dashboard.dae1a6e3.svg";